document.addEventListener('DOMContentLoaded', function () {
  var radioButtons = document.querySelectorAll('input[name="num-collection"]');
  var productLists = document.querySelectorAll('.js-slider-selected');

  radioButtons.forEach(function (radioButton, index) {
    radioButton.addEventListener('change', function () {
      productLists.forEach(function (productList) {
        productList.style.display = 'none';
      });

      productLists[index].style.display = 'block';
    });

    if (index === 0) {
      radioButton.checked = true;
      radioButton.dispatchEvent(new Event('change'));
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var tabUnderline = document.querySelector('.js-tab-underline');
  tabUnderline.style.width = document.querySelector('.js-tab-link.active').offsetWidth + 'px';

  var tabLinks = document.querySelectorAll('.js-tab-link');
  var tabsContainer = document.querySelector('.tabs-container');

  tabLinks.forEach(function (tabLink) {
    tabLink.addEventListener('click', function (e) {
      tabLinks.forEach(function (link) {
        link.classList.remove('js-active-tab');
      });

      this.classList.add('js-active-tab');

      var position = this.getBoundingClientRect();
      var parentPosition = tabsContainer.getBoundingClientRect();

      tabUnderline.style.left = position.left - parentPosition.left + 'px';
      tabUnderline.style.width = this.offsetWidth + 'px';
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const dropdown = document.querySelector('.js-collection-dropdown');
  const sliders = document.querySelectorAll('.js-slider-selected');

  if (dropdown) {
    dropdown.addEventListener('change', (event) => {
      const selectedValue = event.target.value;

      sliders.forEach((slider, index) => {
        slider.style.display = index + 1 == selectedValue ? 'block' : 'none';
      });
    });

    sliders.forEach((slider, index) => {
      slider.style.display = index === 0 ? 'block' : 'none';
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // Elementos del select
  const selectedOption = document.querySelector('.custom-select .selected-option');
  const optionsList = document.querySelectorAll('.custom-select .options li');
  const sliders = document.querySelectorAll('.num-collections__slider .js-slider-selected');

  // Mostrar/Ocultar el menú desplegable
  selectedOption.addEventListener('click', () => {
    const optionsContainer = selectedOption.nextElementSibling;
    const isOpen = optionsContainer.style.display === 'block';
    optionsContainer.style.display = isOpen ? 'none' : 'block';

    // Alternar la clase "open" para cambiar el estado del icono
    selectedOption.classList.toggle('open', !isOpen);
  });

  // Manejar la selección de una colección
  optionsList.forEach((option) => {
    option.addEventListener('click', () => {
      const selectedValue = option.getAttribute('data-value');

      // Actualizar el texto del select manteniendo el ícono
      const selectedText = selectedOption.querySelector('.selected-text');
      if (selectedText) {
        selectedText.textContent = option.textContent;
      }

      // Ocultar todas las colecciones y mostrar la seleccionada
      sliders.forEach((slider, index) => {
        slider.style.display = index + 1 == selectedValue ? 'block' : 'none';
      });

      // Cerrar el menú desplegable
      const optionsContainer = selectedOption.nextElementSibling;
      optionsContainer.style.display = 'none';

      // Asegurar que la clase "open" se remueva
      selectedOption.classList.remove('open');
    });
  });

  // Cerrar el menú desplegable si haces clic fuera
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.custom-select')) {
      const optionsContainer = document.querySelector('.custom-select .options');
      if (optionsContainer) {
        optionsContainer.style.display = 'none';
      }
      selectedOption.classList.remove('open'); // Asegurar que el icono vuelva al estado cerrado
    }
  });
});
